import * as AppConstants from './AppConstants';
import * as AppUtilities from "./AppUtilities";
import * as AppState from "./AppState";
import * as FileSystem from 'expo-file-system';

async function initialize() {
  AppUtilities.info("AppCache.initialize");
}

async function getCachedDefaultData(defaultLink) {
  return null;
}

export {
  initialize,
  getCachedDefaultData,
}
